import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";

export function Ask(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 72 72">
      <circle
        cx="36"
        cy="36.1"
        r="33.8"
        fill="none"
        stroke="#048f96"
        strokeMiterlimit={10}
        strokeWidth={3.8}
      />
      <path
        d="M30.8,47.4c-.2-.6-.4-1.3-.5-2.2-.2-.9-.2-1.8-.2-2.7,0-1.4.3-2.6.8-3.8.6-1.1,1.3-2.2,2.1-3.2.8-1,1.7-1.9,2.7-2.8,1-.9,1.9-1.8,2.7-2.7.8-.9,1.5-1.8,2.1-2.7.6-1,.8-2,.8-3.1s-.2-1.9-.6-2.7c-.4-.8-1-1.4-1.7-1.9-.7-.5-1.5-.9-2.5-1.1-.9-.3-1.9-.4-3-.4-3.4,0-6.6,1.5-9.7,4.5v-7.9c3.7-2.2,7.6-3.3,11.6-3.3s3.6.2,5.2.7,3.1,1.2,4.3,2.1c1.2.9,2.2,2.1,2.9,3.5.7,1.4,1.1,3,1.1,4.9s-.3,3.3-.9,4.7c-.6,1.4-1.3,2.6-2.2,3.8-.9,1.2-1.9,2.2-2.9,3.1s-2,1.8-2.9,2.7c-.9.9-1.6,1.8-2.2,2.8-.6,1-.9,2-.9,3.2s.1,1.9.4,2.7c.2.8.5,1.5.8,2h-7.2ZM34.7,61.9c-1.3,0-2.5-.4-3.5-1.3-1-.9-1.4-1.9-1.4-3.2s.5-2.4,1.4-3.2c1-.9,2.1-1.4,3.5-1.4s2.4.5,3.4,1.4c1,.8,1.4,1.9,1.4,3.2s-.5,2.3-1.4,3.2c-1,.9-2.1,1.3-3.4,1.3Z"
        fill="#048f96"
      />
    </SvgIcon>
  );
}
